/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  background: "#ddeff3",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};
const defaultOption = [
  {
    value: "title",
    label: "title",
    disabled: true,
  },
];

const billIDOption = [
  {
    value: "01GTKT",
    label: "01GTKT",
    disabled: false,
  },
  {
    value: "02GTTT",
    label: "02GTTT",
    disabled: false,
  },
  {
    value: "07KPTQ",
    label: "07KPTQ",
    disabled: false,
  },
  {
    value: "03XKNP",
    label: "03XKNP",
    disabled: false,
  },
  {
    value: "04HGDL",
    label: "04HGDL",
    disabled: false,
  },
  {
    value: "01BHDT",
    label: "01BHDT",
    disabled: false,
  },
  {
    value: "01/",
    label: "01/",
    disabled: false,
  },
  {
    value: "02/",
    label: "02/",
    disabled: false,
  },
  {
    value: "TT120",
    label: "TT120",
    disabled: false,
  },
  {
    value: "01TEDB",
    label: "01TEDB",
    disabled: false,
  },
  {
    value: "01VEDB",
    label: "01VEDB",
    disabled: false,
  },
  {
    value: "01THDB",
    label: "01THDB",
    disabled: false,
  },
  {
    value: "02TEDB",
    label: "02TEDB",
    disabled: false,
  },
  {
    value: "02VEDB",
    label: "02TEDB",
    disabled: false,
  },
  {
    value: "02THDB",
    label: "02TEDB",
    disabled: false,
  },
];

const noteOption = [
  {
    value: "Hóa đơn chưa TBPH",
    label: "Hóa đơn chưa TBPH",
    disabled: false,
  },
  {
    value: "Hóa đơn chưa sử dụng",
    label: "Hóa đơn chưa sử dụng",
    disabled: false,
  },
  {
    value: "Hóa đơn đã viết chưa báo cáo sử dụng",
    label: "Hóa đơn đã viết chưa báo cáo sử dụng",
    disabled: false,
  },
  {
    value: "Hóa đơn đã viết và đã báo cáo sử dụng kỳ trước",
    label: "Hóa đơn đã viết và đã báo cáo sử dụng kỳ trước",
    disabled: false,
  },
  {
    value: "Hóa đơn mua hàng",
    label: "Hóa đơn mua hàng",
    disabled: false,
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: 1,
      bg: true,
    },
    billId: {
      type: "select",
      value: null,
      bg: false,
      option: billIDOption,
    },
    billName: {
      type: "input",
      value: null,
      bg: false,
    },
    denominator: {
      type: "input",
      value: null,
      bg: false,
    },
    symbol: {
      type: "input",
      value: null,
      bg: false,
    },
    quantity: {
      type: "input",
      value: 0,
      bg: false,
    },
    from: {
      type: "input",
      value: null,
      bg: false,
    },
    to: {
      type: "input",
      value: null,
      bg: false,
    },
  },
];
export default function BillBk01Table({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: newIdValue,
        bg: true,
      },
      billId: {
        type: "select",
        value: null,
        bg: false,
        option: billIDOption,
      },
      billName: {
        type: "input",
        value: null,
        bg: false,
      },
      denominator: {
        type: "input",
        value: null,
        bg: false,
      },
      symbol: {
        type: "input",
        value: null,
        bg: false,
      },
      quantity: {
        type: "input",
        value: 0,
        bg: false,
      },
      from: {
        type: "input",
        value: null,
        bg: false,
      },
      to: {
        type: "input",
        value: null,
        bg: false,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Grid item xs={12} style={{ paddingTop: 0 }}>
        <Typography component="label" variant="caption" fontWeight="bold" fontSize={14}>
          3.Các loại hóa đơn chưa sử dụng:
        </Typography>
      </Grid>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Mã loại hóa đơn</Th>
              <Th style={{ textAlign: "center" }}>Tên loại hóa đơn</Th>
              <Th style={{ textAlign: "center" }}>Mẫu số</Th>
              <Th style={{ textAlign: "center" }}>Ký hiệu hóa đơn</Th>
              <Th style={{ textAlign: "center" }}>Số lượng</Th>
              <Th style={{ textAlign: "center" }}>Từ số</Th>
              <Th style={{ textAlign: "center" }}>Đến số</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value + index}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row?.id?.value}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.billId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billId.bg ? (
                      row.billId.value
                    ) : row.billId?.type === "select" ? (
                      <SelectTable
                        name="billId"
                        id={row.id.value}
                        option={row.billId.option ? row.billId.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="billId"
                        value={row.billId.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.billName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billName?.type !== "input" ? (
                      row.billName.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="billName"
                        value={row.billName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.denominator.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.denominator?.type !== "input" ? (
                      row.denominator.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="denominator"
                        value={row.denominator.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.symbol.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.symbol?.type !== "input" ? (
                      row.symbol.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="symbol"
                        value={row.symbol.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantity?.type !== "input" ? (
                      row.quantity.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="quantity"
                        value={row.quantity.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.from.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.from?.type !== "input" ? (
                      row.from.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="from"
                        value={row.from.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.to.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.to?.type !== "input" ? (
                      row.to.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="to"
                        value={row.to.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                colspan="3"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>

              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      type={fields}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
